import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import FeedbackSideSurveyDetail from "./FeedbackSideSurveyDetail";
import SurveyInfoShimmer from "./SurveyInfoShimmer";

const StructurePreviewShimmer = () => {
  return (
    <div className="form_wrap">
      <div className="form_content">
        <form>
          {/* Step 1: Survey Details */}
          <div className="form_section">
            <div className="form_title">
              <h4>
                <span className="sr_number">1</span>Set Survey Details
              </h4>
              <label className="switch_wrap">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={30}
                  width={200}
                />
              </label>
            </div>
            <div className="form_field">
              <SkeletonLoader
                type={"text"}
                count={1}
                height={38}
                width={1120}
              />
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
            </div>
          </div>

          {/* Step 2: Survey Overview */}
          <div className="form_section">
            <div className="form_title">
              <h4>
                <span className="sr_number">2</span>Survey Overview
              </h4>
            </div>
            <div className="form_field has_word_count">
              <SkeletonLoader
                type={"text"}
                count={4.75}
                height={20}
                width={1120}
              />
            </div>
          </div>

          {/* Step 3: Demographics */}
          <div className="form_section">
            <div className="form_title">
              <h4>
                <span className="sr_number">3</span>Demographics (Optional)
              </h4>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={38}
                  width={540}
                />
              </div>
              <div className="form_field"></div>
            </div>
          </div>

          {/* Step 4: Survey Summary */}
          <div className="form_section">
            <div className="form_title">
              <h4>
                <span className="sr_number">4</span>How many people would you
                like to send your test to
              </h4>
              <label className="switch_wrap">
                <SkeletonLoader
                  type={"text"}
                  count={1}
                  height={30}
                  width={200}
                />
              </label>
            </div>

            <div className="step_slider_wrap">
              <SkeletonLoader
                type={"text"}
                count={1}
                height={38}
                width={1120}
              />
            </div>

            <SkeletonLoader type={"text"} count={1} height={38} width={1120} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default StructurePreviewShimmer;
